import { Route, Routes } from 'react-router-dom'
import "./index.css"
import Home from './routes/Home'
import Services from './routes/Services'
import Clients from './routes/Clients'
import Contact from './routes/Contact'
import Navbar from './components/Navbar'
import Loader from './components/Loader'
import Footer from "./components/Footer"
import ScrollToTop from './components/ScrollToTop'
import Redirect from './routes/Redirect'

export default function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Loader />
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/services' element={<Services />} />
        <Route path='/clients' element={<Clients />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='*' element={<Redirect />} />
      </Routes>
      <Footer />
    </div>
  )
}